declare global {
  interface Window {
    dataLayer: unknown[][];
    gtag: (...arguments_: unknown[]) => void;
  }
}

export const initializeGoogleAnalytics = (): void => {
  const measurementId = import.meta.env.VITE_GOOGLE_ANALYTICS_ID?.trim();
  if (!measurementId) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = (...arguments_: unknown[]) => window.dataLayer.push(arguments_);
  window.gtag("js", new Date());
  window.gtag("config", measurementId);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.append(script);
};
